// extracted by mini-css-extract-plugin
export default {"wrap":"Ln-z","logoContainer":"Mn-z","brandImg":"Nn-z","logoImg":"On-z","logoButton":"Pn-z"};